export const ADMINISTRATIVE_ROLES = ['Owner', 'Manager', 'Non admin'];

export const SUPPORT_USER_EMAILS = [
    'ingeniusolutions.com',
    'workroads.com',
    'ingeniu.ca'
];
